export type SlideSenseView = "home" | "all" | "my" | "admin" | "usage" | "help"

export function getSlideSenseViewParam(value: string | null): SlideSenseView | null {
  if (
    value === "home" ||
    value === "all" ||
    value === "my" ||
    value === "admin" ||
    value === "usage" ||
    value === "help"
  ) {
    return value
  }
  return null
}

export function resolveSlideSenseView(
  activeTab: string,
  showMyPresentations: boolean
): SlideSenseView {
  if (activeTab === "home") return "home"
  if (activeTab === "admin") return "admin"
  if (activeTab === "usage") return "usage"
  if (activeTab === "help") return "help"
  return showMyPresentations ? "my" : "all"
}

export function buildSlideSenseViewParams(
  currentParams: URLSearchParams,
  desired: SlideSenseView,
  pendingUrlView: SlideSenseView | null = null
): URLSearchParams | null {
  if (pendingUrlView) return null

  const next = new URLSearchParams(currentParams)
  next.set("view", desired)
  return next.toString() === currentParams.toString() ? null : next
}
